/* Elohim PDP scripts — extracted from elohim-product-template.liquid.
   Product data comes from the static-product data island to avoid
   serializing {{ product | json }} multiple times per page.
   rev: 2026-06-13e — thumbnail gallery = document-level delegation in this
   external asset (verified working in a real browser via puppeteer; the inline
   onclick approach was unreliable on this storefront). Registered first +
   try/catch so nothing else can stop it. */

/* ═══ THUMBNAIL GALLERY — runs first, document-level delegation ═══ */
(function () {
  try {
    function thumbFrom(node) {
      while (node && node.nodeType === 1) {
        if (node.hasAttribute && node.hasAttribute('data-elohim-thumb')) return node;
        node = node.parentNode;
      }
      return null;
    }
    function switchTo(thumb) {
      if (!thumb) return;
      var main = document.getElementById('elohim-main-img');
      if (main) {
        var src = thumb.getAttribute('data-src');
        if (src) {
          /* The main image carries a srcset/sizes (for LCP). srcset overrides src
             for what the browser actually displays, so we MUST clear it — otherwise
             setting .src changes the attribute but not the visible pixels. */
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = src;
        }
        var alt = thumb.getAttribute('data-alt');
        if (alt != null) main.alt = alt;
      }
      var all = document.querySelectorAll('[data-elohim-thumb]');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
      thumb.classList.add('is-active');
    }
    document.addEventListener('click', function (e) {
      var t = thumbFrom(e.target);
      if (t) switchTo(t);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.keyCode !== 13 && e.keyCode !== 32) return;
      var t = thumbFrom(e.target);
      if (t) { e.preventDefault(); switchTo(t); }
    });
    /* Touch tap fallback (scroll-strip swipe guard) */
    var sx = 0, sy = 0, moved = false, tt = null;
    document.addEventListener('touchstart', function (e) {
      tt = thumbFrom(e.target);
      if (!tt) return;
      var p = e.changedTouches[0]; sx = p.clientX; sy = p.clientY; moved = false;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!tt) return;
      var p = e.changedTouches[0];
      if (Math.abs(p.clientX - sx) > 10 || Math.abs(p.clientY - sy) > 10) moved = true;
    }, { passive: true });
    document.addEventListener('touchend', function () {
      if (tt && !moved) switchTo(tt);
      tt = null;
    }, { passive: true });
  } catch (e) { /* never break the rest of the script */ }
})();

var __elohimIsland = (function () {
  try {
    var el = document.querySelector('script[data-section-type="static-product"][data-section-data]');
    return el ? JSON.parse(el.textContent) : {};
  } catch (e) { return {}; }
})();
var __elohimProduct = __elohimIsland.product || {};


  function elohimSwitchMedia(thumb) {
    var img = document.getElementById('elohim-main-img');
    if (img) { img.src = thumb.dataset.src; img.alt = thumb.dataset.alt; }
    document.querySelectorAll('.elohim-pdp__thumb').forEach(function(t){ t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }
  function elohimQtyChange(delta) {
    var input = document.getElementById('elohim-qty');
    input.value = Math.max(1, (parseInt(input.value) || 1) + delta);
  }
  function elohimTab(btn, panelId) {
    document.querySelectorAll('.elohim-pdp__tab-btn').forEach(function(b){
      b.classList.remove('is-active'); b.setAttribute('aria-selected','false');
    });
    document.querySelectorAll('.elohim-pdp__tab-panel').forEach(function(p){ p.classList.remove('is-active'); });
    btn.classList.add('is-active'); btn.setAttribute('aria-selected','true');
    document.getElementById(panelId).classList.add('is-active');
  }
  /* Convert variant weight (any store unit) to grams for consistent comparison.
     cart.total_weight from /cart.js is always in grams; product | json returns
     weight in the store's display unit (lb, kg, oz, or g). */
  function weightToGrams(w, unit) {
    if (!w) return 0;
    switch ((unit || 'g').toLowerCase()) {
      case 'lb': case 'lbs': return w * 453.592;
      case 'kg':             return w * 1000;
      case 'oz':             return w * 28.3495;
      default:               return w; // already grams
    }
  }
  (function () {
   try {
    var productData = __elohimProduct;
    var form = document.getElementById('elohim-product-form');
    if (!form) return;
    var selects = Array.from(form.querySelectorAll('.elohim-pdp__variant-select'));
    function getVariant() {
      var chosen = selects.map(function(s){ return s.options[s.selectedIndex] ? s.options[s.selectedIndex].value : null; });
      return productData.variants.find(function(v){
        return v.options.every(function(opt,i){ return opt === chosen[i]; });
      });
    }
    function updateUI(variant) {
      if (!variant) return;
      var priceEl = document.getElementById('elohim-price');
      if (priceEl) {
        var p = (variant.price/100).toFixed(2);
        var html = '$'+p;
        if (variant.compare_at_price > variant.price) {
          html += '<span class="elohim-pdp__price-compare">$'+(variant.compare_at_price/100).toFixed(2)+'</span>';
        }
        priceEl.innerHTML = html;
      }
      var skuEl = document.getElementById('elohim-sku');
      if (skuEl) skuEl.textContent = variant.sku || '';
      var availEl = document.getElementById('elohim-avail');
      if (availEl) {
        availEl.textContent = variant.available ? 'In Stock' : 'Out of Stock';
        availEl.className = 'elohim-pdp__availability ' +
          (variant.available ? 'elohim-pdp__availability--in' : 'elohim-pdp__availability--out');
      }
      var atcBtn = document.getElementById('elohim-atc-btn');
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? (atcBtn.getAttribute('data-atc-label') || 'Add to Cart') : 'Sold Out';
      }
      var varInput = document.getElementById('elohim-variant-id');
      if (varInput) varInput.value = variant.id;
      var buyNow = document.getElementById('elohim-buynow-btn');
      if (buyNow) {
        var qty = document.getElementById('elohim-qty').value || 1;
        buyNow.href = '/cart/add?id=' + variant.id + '&quantity=' + qty + '&checkout=true';
      }

      /* Heavy freight toggle — 1,000 lbs = 453,592 grams */
      var atcWrapper   = document.getElementById('elc-atc-wrapper');
      var quoteWrapper = document.getElementById('elc-quote-wrapper');
      var quoteBtn     = document.getElementById('elc-quote-btn');
      if (atcWrapper && quoteWrapper) {
        var isHeavy = weightToGrams(variant.weight || 0, variant.weight_unit) > 453592;
        atcWrapper.style.display   = isHeavy ? 'none'  : '';
        quoteWrapper.style.display = isHeavy ? 'flex'  : 'none';
        if (isHeavy && quoteBtn) {
          var productTitle = encodeURIComponent(productData.title);
          var variantTitle = encodeURIComponent(variant.title);
          quoteBtn.href = 'https://wa.me/13469166593?text=Hi!%20I\'m%20interested%20in%20ordering%3A%20'
            + productTitle + '%20-%20' + variantTitle
            + '.%20Can%20you%20send%20me%20a%20freight%20quote%3F';
        }
      }

      if (variant.featured_image) {
        var mi = document.getElementById('elohim-main-img');
        if (mi) {
          /* Clear srcset/sizes so .src is actually displayed (see thumbnail switchTo) */
          mi.removeAttribute('srcset');
          mi.removeAttribute('sizes');
          mi.src = variant.featured_image.src;
        }
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch(e) {}
    }
    selects.forEach(function(s){
      s.addEventListener('change', function(){ var v = getVariant(); if (v) updateUI(v); });
    });
    /* Run on page load to set correct state for default variant */
    var initialVariant = getVariant();
    if (initialVariant) updateUI(initialVariant);
   } catch (e) { /* variant logic must never halt the rest of the PDP script */ }
  })();

  /* ── Visual variant button click handler ──────────────────────────────── */
  (function () {
    document.querySelectorAll('.elohim-opt-group').forEach(function (group) {
      var hiddenSelect = group.querySelector('.elohim-pdp__variant-select');
      var allBtns = group.querySelectorAll('.elohim-swatch, .elohim-tile-btn, .elohim-pack-btn');

      allBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var value = btn.dataset.value;

          /* Update selected state in this group */
          allBtns.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');

          /* Sync the hidden <select> and trigger the existing variant handler */
          if (hiddenSelect) {
            for (var i = 0; i < hiddenSelect.options.length; i++) {
              if (hiddenSelect.options[i].value === value) {
                hiddenSelect.selectedIndex = i;
                break;
              }
            }
            hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        /* Keyboard support */
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
        });
      });
    });
  })();

  /* ── Ajax Add to Cart ─────────────────────────────────────────────────────
     Intercepts the native product form submit so the page never redirects.
     On success: updates the header cart badge and notifies the cart drawer.
  ──────────────────────────────────────────────────────────────────────────── */
  (function () {
    var form   = document.getElementById('elohim-product-form');
    var atcBtn = document.getElementById('elohim-atc-btn');
    if (!form || !atcBtn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atcBtn.disabled) return;

      var variantInput = document.getElementById('elohim-variant-id');
      var qtyInput     = document.getElementById('elohim-qty');
      var variantId    = variantInput ? parseInt(variantInput.value, 10) : null;
      var qty          = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

      if (!variantId) return;

      var origText = atcBtn.textContent;
      atcBtn.textContent = 'Adding…';
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) return Promise.reject(r);
          return fetch('/cart.js', { credentials: 'same-origin' });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* 1. Button feedback */
          atcBtn.textContent = '✓ Added!';
          setTimeout(function () {
            atcBtn.textContent = origText;
            atcBtn.disabled = false;
          }, 1600);

          /* 2. Update header cart badge (Depot listens to cartcount:update) */
          window.dispatchEvent(
            new CustomEvent('cartcount:update', { detail: { item_count: cart.item_count } })
          );

          /* 3. Notify cart drawer / other listeners of the new cart state */
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function () {
          atcBtn.textContent = 'Error — try again';
          atcBtn.disabled = false;
          setTimeout(function () { atcBtn.textContent = origText; }, 2500);
        });
    });
  })();

  /* ── Weight-based warning system ─────────────────────────────────────────
     Shows when cart weight + (variant.weight × qty) would exceed 1,000 lbs.
     Shopify stores variant weights in grams. 1,000 lbs = 453,592 g.
  ──────────────────────────────────────────────────────────────────────────── */
  (function () {
    var LIMIT_G        = 453592;
    var warningEl      = document.getElementById('elohim-weight-warning');
    var weightAtcBtn   = document.getElementById('elohim-weight-atc-btn');
    var weightQuoteBtn = document.getElementById('elohim-weight-quote-btn');
    var variantInput   = document.getElementById('elohim-variant-id');
    var qtyInput       = document.getElementById('elohim-qty');
    var pData          = __elohimProduct;
    var cartWeightG    = 0;
    var atcBusy        = false;

    if (!warningEl) return;

    function currentVariant() {
      var vid = parseInt(variantInput ? variantInput.value : 0, 10);
      return pData.variants.find(function (v) { return v.id === vid; });
    }
    function currentQty() {
      return Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
    }

    /* Show/hide the warning based on projected total weight */
    function checkWeight() {
      var v = currentVariant();
      if (!v) { warningEl.style.display = 'none'; return; }

      var projectedG = cartWeightG + weightToGrams(v.weight || 0, v.weight_unit) * currentQty();

      if (projectedG > LIMIT_G) {
        var totalLbs = (projectedG / 453.592).toFixed(1);
        weightQuoteBtn.href = 'https://wa.me/13469166593?text='
          + encodeURIComponent(
              'Hi! I need a freight quote.\n\nProduct: ' + pData.title
              + '\nVariant: ' + v.title
              + '\nQty: ' + currentQty()
              + '\nEstimated total weight: ' + totalLbs + ' lbs'
              + '\n\nCan you send me a shipping quote?'
            );
        warningEl.style.display = 'block';
      } else {
        warningEl.style.display = 'none';
      }
    }

    /* Fetch current cart weight then re-check */
    function refreshCartWeight() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { cartWeightG = cart.total_weight || 0; checkWeight(); })
        .catch(function () {});
    }
    refreshCartWeight();

    /* Variant changes from hidden selects (triggered by visual buttons) */
    document.querySelectorAll('.elohim-pdp__variant-select').forEach(function (s) {
      s.addEventListener('change', checkWeight);
    });

    /* Quantity typed into input */
    if (qtyInput) {
      qtyInput.addEventListener('input', checkWeight);
      qtyInput.addEventListener('change', checkWeight);
    }

    /* Quantity changed via +/- buttons — patch the global elohimQtyChange */
    var _origQtyChange = window.elohimQtyChange;
    if (typeof _origQtyChange === 'function') {
      window.elohimQtyChange = function (delta) {
        _origQtyChange(delta);
        setTimeout(checkWeight, 10);
      };
    }

    /* Re-check after any cart update (Ajax ATC, cart drawer, etc.) */
    window.addEventListener('cartcount:update', refreshCartWeight);

    /* "Add to Cart Anyway" — bypasses the weight gate, adds directly */
    if (weightAtcBtn) {
      weightAtcBtn.addEventListener('click', function () {
        if (atcBusy) return;
        var v   = currentVariant();
        var qty = currentQty();
        if (!v) return;

        var origText = weightAtcBtn.textContent;
        weightAtcBtn.textContent = 'Adding…';
        weightAtcBtn.disabled = true;
        atcBusy = true;

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: v.id, quantity: qty })
        })
          .then(function (r) { if (!r.ok) return Promise.reject(r); return fetch('/cart.js', { credentials: 'same-origin' }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cartWeightG = cart.total_weight || 0;
            weightAtcBtn.textContent = '✓ Added!';
            setTimeout(function () {
              weightAtcBtn.textContent = origText;
              weightAtcBtn.disabled = false;
              atcBusy = false;
              /* Hide warning — re-check will re-show only if next add also exceeds limit */
              warningEl.style.display = 'none';
              checkWeight();
            }, 1600);
            window.dispatchEvent(new CustomEvent('cartcount:update', { detail: { item_count: cart.item_count } }));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          })
          .catch(function () {
            weightAtcBtn.textContent = 'Error — try again';
            weightAtcBtn.disabled = false;
            atcBusy = false;
            setTimeout(function () { weightAtcBtn.textContent = origText; }, 2500);
          });
      });
    }
  })();


  (function () {
    'use strict';

    /* ───────── Shared helpers ───────── */
    var variantInput = document.getElementById('elohim-variant-id');
    var qtyInput = document.getElementById('elohim-qty');
    function currentVariantId() { return variantInput ? variantInput.value : null; }
    function currentQty() { var q = parseInt(qtyInput && qtyInput.value, 10); return (q > 0) ? q : 1; }

    /* ───────── Low-stock urgency (real inventory) ───────── */
    var lowstockEl = document.getElementById('elohim-lowstock');
    var invScript = document.getElementById('elohim-inventory-data');
    var inventory = {};
    try { inventory = JSON.parse(invScript ? invScript.textContent : '{}'); } catch (e) {}

    function updateLowStock() {
      if (!lowstockEl) return;
      var info = inventory[currentVariantId()];
      if (info && info.managed && info.policy !== 'continue' && info.qty > 0 && info.qty < 10) {
        lowstockEl.textContent = '⚠ Only ' + info.qty + ' left in stock — order soon';
        lowstockEl.style.display = 'block';
      } else {
        lowstockEl.style.display = 'none';
      }
    }

    /* ───────── Sticky ATC bar ───────── */
    var stickyBar = document.getElementById('elohim-sticky-atc');
    var stickyBtn = document.getElementById('elohim-sticky-btn');
    var stickyPrice = document.getElementById('elohim-sticky-price');
    var mainAtcWrapper = document.getElementById('elc-atc-wrapper');
    var mainAtcBtn = document.getElementById('elohim-atc-btn');
    var mainPriceEl = document.getElementById('elohim-price');

    if (stickyBar && mainAtcWrapper && 'IntersectionObserver' in window) {
      stickyBar.style.display = 'flex';
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        /* Show sticky bar only when main ATC is scrolled out AND product is purchasable */
        var quoteMode = mainAtcWrapper.style.display === 'none';
        if (!visible && !quoteMode) {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        } else {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
      }, { rootMargin: '-60px 0px 0px 0px' });
      io.observe(mainAtcWrapper);

      stickyBtn.addEventListener('click', function () {
        if (mainAtcBtn && !mainAtcBtn.disabled) {
          mainAtcBtn.click();
          var orig = stickyBtn.textContent;
          stickyBtn.textContent = '✓ Added!';
          setTimeout(function () { stickyBtn.textContent = orig; }, 1600);
        }
      });
    }

    /* ───────── Keep sticky price, button state + low-stock in sync on variant change ───────── */
    var syncTimer = null;
    function syncAll() {
      updateLowStock();
      if (stickyPrice && mainPriceEl) {
        /* First text node of main price = current price */
        var t = mainPriceEl.childNodes[0];
        if (t) stickyPrice.textContent = t.textContent.trim();
      }
      if (stickyBtn && mainAtcBtn) {
        stickyBtn.disabled = mainAtcBtn.disabled;
        if (mainAtcBtn.disabled) stickyBtn.textContent = 'Sold Out';
      }
    }
    document.addEventListener('click', function () { clearTimeout(syncTimer); syncTimer = setTimeout(syncAll, 200); });
    document.addEventListener('change', function () { clearTimeout(syncTimer); syncTimer = setTimeout(syncAll, 200); });
    syncAll();
  })();

